import Luiv3Constants from '@app/lui3/constants';
import styled from 'styled-components';

const Footer = styled.div`
  background-color: ${Luiv3Constants.baseColor['gray-25']};
  display: flex;
  justify-content: flex-end;
  padding: 1.5rem;
  gap: 0.75rem;
  border-top: 1px solid ${Luiv3Constants.baseColor['gray-100']};
  border-radius: 0 0 1.5rem 1.5rem;
`;

export default Footer;
